import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTask = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M24.5002 9.96621C20.4672 8.15976 15.5798 8.88417 12.2449 12.1578C8.06494 16.2658 7.89958 23.1615 11.8867 27.4621C16.1585 32.0745 23.3702 32.1754 27.7799 27.7739C31.6383 23.9226 32.0242 17.9256 28.965 13.6249L18.9697 23.6017L14.9551 19.5945",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10
	})
});
const ForwardRef = forwardRef(SvgTask);
export default ForwardRef;
